import DestroyOpenStack from './DestroyOpenStack';

export default DestroyOpenStack;
